import { Badge } from '../../Badge/Badge';
import type { BadgeColor } from '../../Badge/Badge.types';
import { useWithholdingsTranslation } from './i18n';
import type { WithholdingOrigin } from './types';

export interface WithholdingOriginBadgeProps {
  /** Origen de la fila (derivado de `isManual`/`isManipulated`). */
  origin: WithholdingOrigin;
}

const ORIGIN_CONFIG: Record<WithholdingOrigin, { color: BadgeColor; labelKey: string }> = {
  manual: { color: 'amber', labelKey: 'withholdings.origin.manual' },
  manipulated: { color: 'violet', labelKey: 'withholdings.origin.manipulated' },
  automatic: { color: 'zinc', labelKey: 'withholdings.origin.automatic' },
};

/**
 * Badge de origen de una retención (FEAT-105-11.01).
 *
 * - `manual` → "Manual" (amber)
 * - `manipulated` → "Modificado" (violet)
 * - `automatic` → "Automático" (zinc)
 *
 * Reutiliza el `Badge` del kit.
 */
export function WithholdingOriginBadge({ origin }: WithholdingOriginBadgeProps) {
  const { t } = useWithholdingsTranslation();
  const { color, labelKey } = ORIGIN_CONFIG[origin];
  return <Badge color={color} label={t(labelKey)} />;
}
